<template>
  <!-- eslint-disable vue/no-unused-vars -->
  <div v-if="value && stars" class="rating">
    <!-- eslint-disable vue/no-unused-vars -->
    <span v-for="i in stars" class="af af-star rating-star rating-star-filled"></span>
    <div v-if="hasHalf" class="rating-star rating-star-half">
      <span class="af af-star-outlined rating-star-outlined"></span>
      <span class="af af-star rating-star-filled"></span>
    </div>
    <!-- eslint-disable vue/no-unused-vars -->
    <span v-for="i in emptyStars" class="af af-star-outlined rating-star rating-star-outlined"></span>
  </div>
</template>
<script>
export default {
  props: ['max', 'value', 'showHalfStar'],

  computed: {
    stars() {
      if (this.hasHalf) {
        return Math.floor(this.value);
      }
      return Math.round(this.value);
    },

    emptyStars() {
      return this.max - this.stars - (this.hasHalf ? 1 : 0);
    },

    hasHalf() {
      return this.showHalfStar && Math.round(this.value * 2) % 2 === 1;
    },
  },
};
</script>

<style lang="postcss">
.rating {
  display: flex;

  .rating-star {
    margin-right: var(--space-2);
  }

  .rating-star-filled {
    color: var(--accent-color);
  }

  .rating-star-outlined {
    color: var(--grey-light);
  }

  .rating-star-half {
    position: relative;
    width: 16px;
    height: 16px;

    .rating-star-outlined {
      direction: rtl;
      margin-left: 8px;
    }

    .rating-star-filled,
    .rating-star-outlined {
      width: 8px;
      overflow: hidden;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
</style>
